<template>
  <div class="filter-part square">
    <el-row class="section-name-block mobile-check-list">
      <img
        src="@/assets/images/square.png"
        class="image-col mobile-version-filter"
        alt="square"
      />
      <h3 class="section-name" :class="{ invalid: errorInput }">
        Площа <span class="square-icon-text">м<sup>2</sup></span> :
      </h3>
    </el-row>
    <el-row :gutter="40" class="square-content">
      <!-- needed custom tooltip implementation-->
      <span  v-if="selectedValue.start==1" class="range-slider-tooltip left">min</span>
      <span  v-else class="range-slider-tooltip left">{{ selectedValue.start }}</span>
      <span  v-if="selectedValue.end==1000" class="range-slider-tooltip right">max</span>
      <span v-else  class="range-slider-tooltip right">{{ selectedValue.end }}</span>
      <el-col class="slider-col" :lg="12">
        <el-slider
          tooltip-class="range-slider-tooltip"
          v-model="sliderValue"
          :show-tooltip="false"
          range
          :step="2"
          :min="10"
          :max="100"
          @input="sliderHandler"
          @change="confirmChangeHandler"
        />
        <div class="below-slider-content">
          <p class="min-val">{{ min }}</p>
          <p class="max-val">100 +</p>
        </div>
      </el-col>
      <el-col :lg="12" class="inputs-block">
        <el-row :gutter="10">
          <el-col :lg="10" class="input-wrapper">
            <el-input
              v-model="input.start"
              placeholder="Від"
              :class="{ error: errorInput }"
              @input="inputHandlerDebounced"
            >
              <template slot="prepend">Від</template>
            </el-input>
          </el-col>
          <el-col :lg="10" class="input-wrapper">
            <el-input
              v-model="input.end"
              placeholder="До"
              :class="{ error: errorInput }"
              @input="inputHandlerDebounced"
            >
              <template slot="prepend">До</template>
            </el-input>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xl="12" :lg="12" class="inputs-block mobile-price-input">
        <el-row :gutter="10">
          <el-col :xl="6" :lg="12" :span="12" class="input-wrapper">
            <el-input
              v-model="input.start"
              placeholder="Від"
              :class="{ error: errorInput }"
              @blur="inputHandlerDebounced"
            >
            </el-input>
          </el-col>
          <el-col :xl="6" :lg="12" :span="12" class="input-wrapper">
            <el-input
              v-model="input.end"
              placeholder="До"
              :class="{ error: errorInput }"
              @input="inputHandlerDebounced"
            >
            </el-input>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const debounce = require('lodash.debounce')
export default {
  name: 'Square',
  props: ['min', 'max', 'selectedValue'],
  computed: {
    ...mapGetters({
      flatFilter: 'getFlatsFilter',
    }),
  },
  mounted() {
    this.setCoordsTooltip()
    this.input.start = this.selectedValue.start
    this.input.end = this.selectedValue.end
  },
  watch: {
    'selectedValue.start'(newValue) {
      if (newValue >= this.min)
        this.sliderValue = [+newValue, +this.selectedValue.end]
      this.input.start = newValue
    },
    'selectedValue.end'(newValue) {
      if (newValue <= this.max)
        this.sliderValue = [+this.selectedValue.start, +newValue]
      this.input.end = newValue
    },
  },
  data() {
    return {
      sliderValue: [+this.selectedValue.start, +this.selectedValue.end],
      errorInput: false,
      input: {
        start: '',
        end: '',
      },
    }
  },
  methods: {
    inputHandlerDebounced: debounce(function () {
      this.confirmChangeHandler()
    }, 1000),
    sliderHandler() {
      const mins = this.sliderValue[0] == 10  ? this.min : this.sliderValue[0]
      const maxs  = this.sliderValue[1] == 100 ? this.max : this.sliderValue[1]  

      this.$store.commit('setFlatFilter', {
        ...this.flatFilter,
        ...{
          area: { start: +mins, end: +maxs },
        },
      })
    },
    confirmChangeHandler() {
      this.errorInput = false
      if (
        +this.input.start >= +this.input.end ||
        +this.input.start < +this.min ||
        +this.input.end > +this.max
      ) {
        this.errorInput = true
        return
      }
      this.$emit('change', this.input)
    },
    setCoordsTooltip() {
      const leftTooltip = document.querySelector(
        '.square .range-slider-tooltip.left'
      )
      const rightTooltip = document.querySelector(
        '.square .range-slider-tooltip.right'
      )
      const sliderBtns = document.querySelectorAll('.square .el-slider__button')
      sliderBtns[0].append(leftTooltip)
      sliderBtns[1].append(rightTooltip)
    },
  },
}
</script>
